import { Icon } from '../panels/Icon';
import { useIconSrc } from './hooks';

/** A record's sprite icon from Unity, or a neutral placeholder. */
export function DataIcon({
  iconKey,
  size = 20,
  fallback = 'poi',
}: {
  iconKey?: string | null;
  size?: number;
  fallback?: string;
}) {
  const src = useIconSrc(iconKey);
  if (src) return <img className="data-icon" src={src} width={size} height={size} alt="" />;
  return (
    <span className="data-icon placeholder" style={{ width: size, height: size }}>
      <Icon id={fallback} size={Math.round(size * 0.7)} />
    </span>
  );
}
